export default {
  name: `rotate_screen`,
  cta: `Pivotez votre écran en mode portrait, merci !`,
};
